import Segmento from './Segmento';

export default class Banco {

	public id: number;
	public canalId: number;
	public nome: string;
	public taxaAdm: number;
	public segmentos: Array<Segmento>;

	constructor(object?: BancoInterface) {
		if(object)
			for(let key of Object.keys(object))
				this[key] = object[key];
	}

	public static convert(object: any): Banco {
		let banco: Banco = new Banco(JSON.parse(JSON.stringify(object), (key, value) => {
			if(key === 'segmentos') {
				let segmentos: Array<Segmento> = [];
				for(let item of value)
					segmentos.push(new Segmento(item));

				return segmentos;
			}
			return value;
		}));
		return banco;
	}
}

interface BancoInterface {
	id: number;
	canalId: number;
	nome: string;
	taxaAdm: number;
	segmentos: Array<Segmento>;
}



// WEBPACK FOOTER //
// ./src/base/Banco.ts